import Styles from "./CSSConstants.module.scss";

const DELIMITER = "__";
const classes = Object.keys(Styles);

const filterByPrefix = (strings: string[], prefix: string) =>
  strings.filter((key) => key.indexOf(`${prefix}${DELIMITER}`) === 0);

// BREAKPOINTS
const BREAKPOINT_PREFIX = "breakpoint";

const breakpointClasses = filterByPrefix(classes, BREAKPOINT_PREFIX);

type BreakpointName = "xs" | "sm" | "md" | "lg" | "xl";

interface Breakpoint<BP extends BreakpointName = any> {
  prefix: typeof BREAKPOINT_PREFIX;
  name: BP;
  min: number;
  max: number;
}

const parseBreakpoint = (breakpointString: string): Breakpoint => {
  const [prefix, name, minString, maxString] = breakpointString.split(DELIMITER);
  const min = parseInt(minString.split("px")[0], 10);
  const max = parseInt(maxString.split("px")[0], 10);

  return { prefix, name, min, max } as Breakpoint;
};

export const breakpoints = breakpointClasses
  .map(parseBreakpoint)
  .reduce((acc, bp) => Object.assign(acc, { [bp.name]: bp }), {} as { [key in BreakpointName]: Breakpoint<key> });
